module.exports = __webpack_public_path__ + "img/stock1.9e622b16.png";